import { render, staticRenderFns } from "./AppAuthenticationButton.vue?vue&type=template&id=0bc2e8bc&scoped=true&"
import script from "./AppAuthenticationButton.vue?vue&type=script&lang=ts&"
export * from "./AppAuthenticationButton.vue?vue&type=script&lang=ts&"
import style0 from "./AppAuthenticationButton.vue?vue&type=style&index=0&id=0bc2e8bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc2e8bc",
  null
  
)

export default component.exports